module.exports = __webpack_public_path__ + "img/thumbnail_RedDeer_f_leucistic.e015b272.png";